"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAR_MESSAGE_ACTIONS = void 0;
var STAR_MESSAGE_ACTIONS;
(function (STAR_MESSAGE_ACTIONS) {
    STAR_MESSAGE_ACTIONS["MARK"] = "MARK";
    STAR_MESSAGE_ACTIONS["UNMARK"] = "UNMARK";
})(STAR_MESSAGE_ACTIONS || (exports.STAR_MESSAGE_ACTIONS = STAR_MESSAGE_ACTIONS = {}));
